import React from 'react';
import { LbLinearProgress } from '../../../../../shared/components/ui-components';
import classes from './SellingInfo.module.scss';
import { getPriceView } from '../../../../../shared/utils/stringUtils';
import { DiffPercentLabel } from '../../../../../shared/components/ui-components/DiffPercentLabel/DiffPercentLabel';

type SellingInfoProps = {
  name: string;
  value: number;
  percentDiff: number;
  totalAmount: number;
  isFulfilled: boolean;
};

const SellingInfo = ({
  name,
  value,
  percentDiff,
  totalAmount,
  isFulfilled,
}: SellingInfoProps) => {
  return (
    <div>
      <div className={classes.sellingInfo}>
        <p className={classes.name}>{name}</p>
        <p className={classes.incomeInfo}>
          {/* totalAmount is in cents, convert to dollars */}
          <span>{getPriceView(totalAmount / 100)}</span>
          <DiffPercentLabel percentValue={percentDiff} className={classes.diffWrapper} />
        </p>
      </div>
      <LbLinearProgress
        size="small"
        value={value}
        color={isFulfilled ? 'success' : 'neutral'}
      />
    </div>
  );
};

export { SellingInfo };
